import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AdminService } from './services/admin.service';
import { locale as enLocale } from './modules/i18n/vocabs/en';
import { locale as esLocale } from './modules/i18n/vocabs/es';
import { locale as ptLocale } from './modules/i18n/vocabs/pt';
import { locale as frLocale } from './modules/i18n/vocabs/fr';
import { TranslationService } from './modules/i18n/translation.service';
import { LayoutComponent } from './components/layout/layout/layout.component';
import { AuthService } from './services/auth.service';
import { CompaniesService } from './services/company.service';
import { Subscription } from 'rxjs';
import { CreateEditCompanyComponent } from './components/dialogs/create-edit-company/create-edit-company.component';
import { MatDialog } from '@angular/material/dialog';
import { CompanyModel } from './models/company.model';

@Component({
	selector: 'body[root]',
	templateUrl: './app.html',
	styleUrl: './app.scss',
	imports: [RouterOutlet, LayoutComponent],
	standalone: true,
})
export class App implements OnInit {
	private subscription: Subscription[] = [];
	private companiesService = inject(CompaniesService);
	private adminService = inject(AdminService);
	isAdmin = false;
	private translationService: TranslationService = inject(TranslationService);
	private auth = inject(AuthService);
	private dialog = inject(MatDialog);
	private company: CompanyModel | null = null;
	constructor() {
		this.adminService.isLoyaltyAdmin$.subscribe((isAdmin) => {
			this.isAdmin = isAdmin;
		});
		this.auth.getUserByToken();
		this.subscription.push(
			this.companiesService.addPopup$.subscribe((r) => {
				if (r) {
					this.showCreateCompany();
				}
			})
		);
	}

	ngOnInit(): void {
		this.translationService.loadTranslations(ptLocale, enLocale, esLocale, frLocale);
		this.translationService.setLanguage('en');
	}

	showCreateCompany() {
		const dialogRef = this.dialog.open(CreateEditCompanyComponent, {
			maxWidth: '100%',
			width: '100%',
			height: '100%',
		});

		dialogRef.afterClosed().subscribe((result) => {
			this.checkNoInstances();
		});
	}

	checkNoInstances() {
		this.companiesService.getActiveCompany();
		this.company = this.companiesService.company;
		this.companiesService.list({}).subscribe((r) => {
			if (r.data?.length > 0) {
				if (r.total === 0) {
					this.companiesService.clearCompany();
				} else {
					let selected = false;
					r.data.forEach((company: CompanyModel) => {
						if (this.company && company.uuid === this.company.uuid && !this.company.active) {
							selected = true;
							this.companiesService.setActiveCompany(new CompanyModel());
							this.companiesService.setActiveCompany(new CompanyModel(company));
							return;
						} else if (this.company && company.uuid === this.company.uuid && this.company.active) {
							selected = true;
							this.companiesService.setActiveCompany(new CompanyModel(company));
						}
					});
					if (!selected) {
						this.companiesService.setActiveCompany(new CompanyModel(r.data[0]));
					}
				}
			} else {
				this.showCreateCompany();
			}
		});
	}
}
